import React, { useEffect, useState } from "react";
import { useReactiveVar } from "react-reactive-var";
import { isElectronRunning, showSideMenu } from "../../../App";
import {
  forcedElectronChrome,
  forcedElectronChromePlatform,
} from "../../Utils/forceElectronChrome";
import AppAssets from "@toothfairy/shared-ui/AppAssets";
import { AppIcon } from "@toothfairy/shared-ui";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
const WindowControls = () => {
  const [isMaximized, setIsMaximized] = useState(false);
  const { currentTheme } = AppTheme.useTheme();

  const forcedChrome = useReactiveVar(forcedElectronChrome);
  const forcedPlatform = useReactiveVar(forcedElectronChromePlatform);
  const [realPlatform, setRealPlatform] = useState(null);

  useEffect(() => {
    if (isElectronRunning() && window.electronAPI && !forcedChrome) {
      // Get platform information
      window.electronAPI.getPlatform().then(setRealPlatform);

      // Check initial maximized state
      window.electronAPI.windowIsMaximized().then(setIsMaximized);

      // Listen for window state changes (if needed)
      const handleResize = () => {
        if (window.electronAPI) {
          window.electronAPI.windowIsMaximized().then(setIsMaximized);
        }
      };

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, [forcedChrome]);

  const platform = forcedChrome ? forcedPlatform : realPlatform;

  const handleMinimize = () => {
    window.electronAPI?.windowMinimize?.();
  };

  const handleMaximize = () => {
    if (!window.electronAPI?.windowMaximize) return;
    window.electronAPI.windowMaximize().then(() => {
      // Update state after action
      window.electronAPI.windowIsMaximized().then(setIsMaximized);
    });
  };

  const handleClose = () => {
    window.electronAPI?.windowClose?.();
  };

  const isWindows = platform === "win32";
  const isLinux = platform === "linux";

  // Windows and Linux both use window controls on the right side
  if (isWindows || isLinux) {
    return (
      <div
        id="window-controls"
        style={{
          display: "flex",
          height: "32px",
          alignItems: "stretch",
          gap: "5px",
        }}
      >
        <AppIcon
          icon={AppAssets?.icons?.separator}
          color={currentTheme?.theme?.mediumGrey}
          isActive={false}
          size={18}
        />
        <AppIcon
          isHoverable
          isClickable
          onPress={handleMinimize}
          icon={AppAssets?.icons.windowMinimise}
          size={12}
          color={currentTheme?.theme?.mediumGrey}
          activeColor={currentTheme?.theme?.primary}
        />
        {isMaximized ? (
          <AppIcon
            isHoverable
            isClickable
            onPress={handleMaximize}
            icon={AppAssets?.icons.windowRestore}
            size={12}
            color={currentTheme?.theme?.mediumGrey}
            activeColor={currentTheme?.theme?.primary}
          />
        ) : (
          <AppIcon
            isHoverable
            isClickable
            onPress={handleMaximize}
            icon={AppAssets?.icons.windowMaximise}
            size={12}
            color={currentTheme?.theme?.mediumGrey}
            activeColor={currentTheme?.theme?.primary}
          />
        )}

        <AppIcon
          icon={AppAssets?.icons.windowClose}
          size={12}
          isHoverable
          isClickable
          onPress={handleClose}
          color={currentTheme?.theme?.mediumGrey}
          activeColor={currentTheme?.theme?.red}
        />
      </div>
    );
  }

  return null;
};

export default WindowControls;
